import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css'

const Footer = () => {
    return (
     <div className='container-fluid bg-dark mt-1'>
            <div className='container'>
            <div className='row'>
                <div className='col-md-3 mt-5 mb-5 text-light'>
                    <h4>MyShop</h4>               
                    <br />
                    <p className='text-justify'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis repudiandae expedita laboriosam possimus corporis eligendi aut ipsa mollitia sit esse! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    </p>   
                    <div>
                    <a href="https://www.google.com/"><i className="fa-brands fa-facebook logo"></i></a> 
                    <a href="https://www.google.com/"><i className="fa-brands fa-instagram logo"></i></a> 
                    <a href="https://www.google.com/"><i className="fa-brands fa-linkedin logo"></i></a> 
                    <a href="https://www.google.com/"><i className="fa-brands fa-youtube logo"></i></a>                  

                    </div>           
                </div>
                 <div className='col-md-3 mt-5 mb-5 text-light'>
                    <h4>Our Services</h4>
                    <br />
                    <p>Electronics Product</p>
                    <p>Foods Items</p>
                    <p>Clothes Items</p>
                    <p>Facial Item</p>
                </div>
                <div className='col-md-3 mt-5 mb-5 text-light'>
                    <h4>Quick Link</h4>
                    <br />
                    <p><Link className='text-decoration-none text-light' to="/shop">Shop</Link></p> 
                    <p><Link className='text-decoration-none text-light' to="/shop">Home</Link></p> 
                    <p><Link className='text-decoration-none text-light' to="/shop">Shop</Link></p> 
                    <p><Link className='text-decoration-none text-light' to="/shop">Home</Link></p>
                </div>
                <div className='col-md-3 mt-5 mb-5 text-light'>
                    <h4>MyShop</h4>
                    <br />
                    <h5>TolarBag Mirpur 1, Dhaka Bangladesh.</h5>
                    <p>+8801742162172</p>
                    <p>mahfuzkst2@gmail.com</p>                
                </div>
            </div>
        </div>            
     </div>  
    );
};

export default Footer;